import React from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { MenuHeader } from "../settings/MenuHeader";
import {
  Divider,
  InputLabel,
  SettingInput,
  SettingMenu,
  SettingOption
} from "../settings/styles";
import { TopLevelSettingOption } from "../settings/TopLevelSettings";

const toPercentageFormat = (multiplier: number): string =>
  multiplier * 100 + " %";

const subtitlesSizeMultipliers = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

type OptionsProps = {
  onClickBack: () => void;
  onBlur: (event) => void;
};

export const SubtitlesSizeOptions = ({ onBlur, onClickBack }: OptionsProps) => {
  const { useStoreState } = usePlayerStore();
  const setSubtitlesSizeMultiplier = useStoreState.setSubtitlesSizeMultiplier();
  const subtitlesSizeMultiplier = useStoreState.subtitlesSizeMultiplier();
  const uiSize = useStoreState.uiSize();

  return (
    <>
      <MenuHeader backToTopLevel={onClickBack} label="tekstityksien_koko" />
      <Divider />
      <SettingMenu role="menu">
        {subtitlesSizeMultipliers.map(item => (
          <SettingOption key={item}>
            <SettingInput
              checked={subtitlesSizeMultiplier === item}
              id={`subtitles-size-setting-${item}`}
              name="subtitles-size"
              onBlur={onBlur}
              onChange={() => setSubtitlesSizeMultiplier(item, true)}
              onClick={onClickBack}
              type="radio"
              value={item}
            />
            <InputLabel
              htmlFor={`subtitles-size-setting-${item}`}
              uiSize={uiSize}>
              {toPercentageFormat(item)}
            </InputLabel>
          </SettingOption>
        ))}
      </SettingMenu>
    </>
  );
};

type TopLevelOptionProps = {
  onBlur: (event: React.FocusEvent<HTMLElement>) => void;
  onClick: () => void;
};

export const SubtitlesSizeTopLevelOption = ({
  onBlur,
  onClick
}: TopLevelOptionProps) => {
  const { useStoreState } = usePlayerStore();
  const subtitlesSizeMultiplier = useStoreState.subtitlesSizeMultiplier();
  const { language } = useEmbedParametersContext();

  return (
    <TopLevelSettingOption
      onBlur={onBlur}
      onClick={onClick}
      title={i18n("tekstityksien_koko", { language })}
      value={toPercentageFormat(subtitlesSizeMultiplier)}
    />
  );
};
